class TMv_VCS_MainMenus {

	element;
	back_button;

	constructor(element, params) {

		// Save the element for use in other methods
		this.element = element;

		// Find all the top_level menu items that have
		this.element.querySelectorAll('.has_children > .TCv_Link').forEach(menu_item => {
			menu_item.addEventListener('click',this.handleNavMenuClick.bind(this));
		});

		// Get the back button and add the event listener it's click
		this.back_button = this.element.querySelector('.back_button .TCv_Link');
		this.back_button.addEventListener('click', this.handleBackButtonClick.bind(this));
	}


	/**
	 * Event handler for the back button
	 * @param event
	 */
	handleBackButtonClick(event) {
		this.element.classList.remove('showing_menu');
		this.removeShowMenuClasses();
	}

	/**
	 * Removes the show_menu class from all the elements
	 */
	removeShowMenuClasses() {
		this.element.querySelectorAll('.show_menu').forEach(el => {
			el.classList.remove('show_menu');
		});
	}

	/**
	 * Triggered when an appropriate item is selected
	 * @param {Event} event
	 */
	handleNavMenuClick(event) {

		// Link doesn't navigate, shows submenu
		event.preventDefault();

		// Find out if we clicked on the same menu, which should toggle
		let is_same_menu = event.currentTarget.closest('li').classList.contains('show_menu');

		this.removeShowMenuClasses();

		// Find the parent LI, add the show_menu to the current menu item
		// Only bother if it's a different menu. Otherwise, the removal above handled hiding it (toggle)
		if(!is_same_menu)
		{
			event.currentTarget.closest('li').classList.add('show_menu');
		}

		// Tag the whole list has showing the menu
		this.element.classList.add('showing_menu');

	}
}
